module.exports = __webpack_public_path__ + "static/media/facebook.20a6face.svg";